import { render, staticRenderFns } from "./AuditReason.vue?vue&type=template&id=ed4d6864&scoped=true"
import script from "../../assets/ts/tripinfo/AuditReason.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/tripinfo/AuditReason.ts?vue&type=script&lang=ts&external"
import style0 from "./AuditReason.vue?vue&type=style&index=0&id=ed4d6864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d6864",
  null
  
)

export default component.exports